import React, { useEffect } from 'react';
import ElectronHelper from 'src/common/electron/ElectronHelper';
import { RetailElectronAPI } from 'src/common/electron/RetailElectronAPI';
import {
  AuthProvider,
  DEFAULT_REACT_APP_LOGOFF_REDIRECT_URL,
  DEFAULT_REACT_APP_REDIRECT_URL,
  useAuthContext,
} from './auth-context';

const getEnvVars = () => {
  const { REACT_APP_REDIRECT_URL, REACT_APP_LOGOFF_REDIRECT_URL } = ElectronHelper.isElectron()
    ? RetailElectronAPI.getEnvironmentVariables()
    : process.env;
  return { REACT_APP_REDIRECT_URL, REACT_APP_LOGOFF_REDIRECT_URL };
};

export const isAuthRedirect = () => {
  const { REACT_APP_LOGOFF_REDIRECT_URL, REACT_APP_REDIRECT_URL } = getEnvVars();
  const authRedirect =
    window.location.pathname === (REACT_APP_REDIRECT_URL || DEFAULT_REACT_APP_REDIRECT_URL);
  const signOutRedirect =
    window.location.pathname ===
    (REACT_APP_LOGOFF_REDIRECT_URL || DEFAULT_REACT_APP_LOGOFF_REDIRECT_URL);
  return authRedirect || signOutRedirect;
};

const AuthRedirectConsumer: React.FC = () => {
  const { loading, signinPopupCallback, signOutCallback } = useAuthContext();

  useEffect(() => {
    if (!loading) {
      const { REACT_APP_LOGOFF_REDIRECT_URL, REACT_APP_REDIRECT_URL } = getEnvVars();

      const authRedirect =
        window.location.pathname === (REACT_APP_REDIRECT_URL || DEFAULT_REACT_APP_REDIRECT_URL);
      const signOutRedirect =
        window.location.pathname ===
        (REACT_APP_LOGOFF_REDIRECT_URL || DEFAULT_REACT_APP_LOGOFF_REDIRECT_URL);
      if (authRedirect) {
        signinPopupCallback();
      }
      if (signOutRedirect) {
        signOutCallback();
      }
    }
  }, [loading, signinPopupCallback, signOutCallback]);

  return <></>;
};

export const AuthRedirect: React.FC = () => {
  return (
    <AuthProvider>
      <AuthRedirectConsumer />
    </AuthProvider>
  );
};
